// Traduções da aba Infrações do módulo de Gestões (29/10/2026). Coletadas por glob em
// core/i18n/messages.ts.
export default {
  pt: {
    'gestaoInfracoes.aba': 'Infrações',
    'gestaoInfracoes.titulo': 'Infrações classificadas como Gestão',
    'gestaoInfracoes.hint': 'As infrações de jornada classificadas como Gestão, com as colunas do Relatório de Infrações como estavam no momento da classificação. A linha continua aqui depois que a ATS corrige o ponto.',
    'gestaoInfracoes.contagem_one': '{{count}} infração',
    'gestaoInfracoes.contagem_other': '{{count}} infrações',
    'gestaoInfracoes.vazio': 'Nenhuma infração classificada como Gestão com os filtros atuais.',
    'gestaoInfracoes.kpi.total': 'Infrações',
    'gestaoInfracoes.kpi.totalHint': 'Classificadas como Gestão no período',
    'gestaoInfracoes.kpi.colaboradores': 'Colaboradores',
    'gestaoInfracoes.kpi.colaboradoresHint': 'Com infração classificada no período',
    'gestaoInfracoes.kpi.corrigidas': 'Corrigidas pela ATS',
    'gestaoInfracoes.kpi.corrigidasHint': 'Já saíram do Relatório de Infrações',
    'gestaoInfracoes.kpi.semGestao': 'Sem gestão gerada',
    'gestaoInfracoes.kpi.semGestaoHint': 'Ainda sem gestão no módulo',
    'gestaoInfracoes.col.classificacao': 'Classificação',
    'gestaoInfracoes.col.gestao': 'Gestão',
    'gestaoInfracoes.col.situacao': 'Situação',
    'gestaoInfracoes.semGestao': 'Sem gestão gerada',
    'gestaoInfracoes.corrigida': 'Corrigida pela ATS',
    'gestaoInfracoes.corrigidaDica': 'A infração saiu do Relatório de Infrações depois da classificação, quase sempre porque a ATS corrigiu o ponto. A linha mostra o que estava na tela quando ela foi classificada.',
    'gestaoInfracoes.noRelatorio': 'No Relatório de Infrações',
    'gestaoInfracoes.parcial': 'Registro parcial',
    'gestaoInfracoes.parcialDica': 'A infração já tinha saído do Relatório de Infrações quando esta aba foi criada. Vieram os dados que a gestão guardava, e a escala, o veículo e a diária foram lidos depois. Refeição, distância e hora extra ficam em branco, porque a correção do ponto as recalculou.',
  },
  en: {
    'gestaoInfracoes.aba': 'Violations',
    'gestaoInfracoes.titulo': 'Violations classified as Measure',
    'gestaoInfracoes.hint': 'Working time violations classified as Measure, with the Violations report columns as they were when classified. The row stays here after ATS corrects the time clock.',
    'gestaoInfracoes.contagem_one': '{{count}} violation',
    'gestaoInfracoes.contagem_other': '{{count}} violations',
    'gestaoInfracoes.vazio': 'No violation classified as Measure with the current filters.',
    'gestaoInfracoes.kpi.total': 'Violations',
    'gestaoInfracoes.kpi.totalHint': 'Classified as Measure in the period',
    'gestaoInfracoes.kpi.colaboradores': 'Employees',
    'gestaoInfracoes.kpi.colaboradoresHint': 'With a classified violation in the period',
    'gestaoInfracoes.kpi.corrigidas': 'Corrected by ATS',
    'gestaoInfracoes.kpi.corrigidasHint': 'No longer in the Violations report',
    'gestaoInfracoes.kpi.semGestao': 'No measure created',
    'gestaoInfracoes.kpi.semGestaoHint': 'Still without a measure in the module',
    'gestaoInfracoes.col.classificacao': 'Classification',
    'gestaoInfracoes.col.gestao': 'Measure',
    'gestaoInfracoes.col.situacao': 'Status',
    'gestaoInfracoes.semGestao': 'No measure created',
    'gestaoInfracoes.corrigida': 'Corrected by ATS',
    'gestaoInfracoes.corrigidaDica': 'The violation left the Violations report after it was classified, almost always because ATS corrected the time clock. The row shows what was on screen when it was classified.',
    'gestaoInfracoes.noRelatorio': 'In the Violations report',
    'gestaoInfracoes.parcial': 'Partial record',
    'gestaoInfracoes.parcialDica': 'The violation had already left the Violations report when this tab was created. The data the measure kept came along, and the schedule, vehicle and per diem were read later. Meal, distance and overtime stay blank, because the time-clock correction recalculated them.',
  },
  es: {
    'gestaoInfracoes.aba': 'Infracciones',
    'gestaoInfracoes.titulo': 'Infracciones clasificadas como Gestión',
    'gestaoInfracoes.hint': 'Las infracciones de jornada clasificadas como Gestión, con las columnas del Informe de Infracciones como estaban al clasificarlas. La fila sigue aquí después de que ATS corrige el fichaje.',
    'gestaoInfracoes.contagem_one': '{{count}} infracción',
    'gestaoInfracoes.contagem_other': '{{count}} infracciones',
    'gestaoInfracoes.vazio': 'Ninguna infracción clasificada como Gestión con los filtros actuales.',
    'gestaoInfracoes.kpi.total': 'Infracciones',
    'gestaoInfracoes.kpi.totalHint': 'Clasificadas como Gestión en el período',
    'gestaoInfracoes.kpi.colaboradores': 'Colaboradores',
    'gestaoInfracoes.kpi.colaboradoresHint': 'Con infracción clasificada en el período',
    'gestaoInfracoes.kpi.corrigidas': 'Corregidas por ATS',
    'gestaoInfracoes.kpi.corrigidasHint': 'Ya salieron del Informe de Infracciones',
    'gestaoInfracoes.kpi.semGestao': 'Sin gestión generada',
    'gestaoInfracoes.kpi.semGestaoHint': 'Todavía sin gestión en el módulo',
    'gestaoInfracoes.col.classificacao': 'Clasificación',
    'gestaoInfracoes.col.gestao': 'Gestión',
    'gestaoInfracoes.col.situacao': 'Situación',
    'gestaoInfracoes.semGestao': 'Sin gestión generada',
    'gestaoInfracoes.corrigida': 'Corregida por ATS',
    'gestaoInfracoes.corrigidaDica': 'La infracción salió del Informe de Infracciones después de clasificarla, casi siempre porque ATS corrigió el fichaje. La fila muestra lo que estaba en pantalla cuando se clasificó.',
    'gestaoInfracoes.noRelatorio': 'En el Informe de Infracciones',
    'gestaoInfracoes.parcial': 'Registro parcial',
    'gestaoInfracoes.parcialDica': 'La infracción ya había salido del Informe de Infracciones cuando se creó esta pestaña. Vinieron los datos que la gestión guardaba, y la escala, el vehículo y el viático se leyeron después. Comida, distancia y horas extra quedan en blanco, porque la corrección del registro las recalculó.',
  },
}
